document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.youtube-video').forEach(video => {
        video.addEventListener('click', () => {
            const id = video.dataset.id;

            video.innerHTML = `
            <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1"
                title="YouTube video player"
                frameborder="0"
                allowfullscreen
                allow="autoplay; encrypted-media; picture-in-picture"
            ></iframe>
        `;
        });
    });
    document.querySelectorAll('.local-video').forEach(video => {
        video.addEventListener('click', () => {
            const id = video.dataset.id;
            video.classList.add('is-playing');
            document.getElementById(id).play();
        });
    });
});
